
import mcTexturesFile from 'minecraft-textures/dist/textures/json/1.20.id.json';
export { default as mcData } from 'minecraft-data/minecraft-data/data/pc/1.20/blocks.json';
export const mcTextures = mcTexturesFile.items;
export const mcVersion = '1.20';
